import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserCollectionAlbumCard } from '../user-collection-album-card.model';

@JsonObject('UserCollectionAlbumCardsResultsResponse')
export class UserCollectionAlbumCardsResultsResponse extends ApiResultsResponse<UserCollectionAlbumCard> {

  @JsonProperty('results', [UserCollectionAlbumCard])
  override results: UserCollectionAlbumCard[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
